<template>
  <div class="col-12 ps-3">
    <div class="row">
      <div class="col-12">
        <div class="mb-3 d-flex align-items-center">
          <label class="col-form-label" style="width: 16%; flex-shrink: 0;">Send mail to</label>
          <div style="width: 75%;">
            <input 
              v-model="mail_to" 
              @change="savefield('g_adminmailtexts',mailtext_id,'mail_to',mail_to)"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3 d-flex align-items-center">
          <label class="col-form-label" style="width: 16%; flex-shrink: 0;">Mail subject</label>
          <div style="width: 75%;">
            <input 
              v-model="mailtext_subject" 
              @change="savefield('g_adminmailtexts',mailtext_id,'mailtext_subject',mailtext_subject)"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3">
          <label class="form-label">Body text (the invoice is attached automatically)</label>
          <vue-editor 
            v-model="mailtext_text" 
            :editorToolbar="editortoolbar" 
            @text-change="savefield('g_adminmailtexts',mailtext_id,'mailtext_text',mailtext_text)"
          ></vue-editor>
        </div>
      </div>
      <div class="form-group col-12 mt-4">
        <button 
          v-if="mailtext_id < 1" 
          @click.prevent="mailtext_create" 
          class="btn btn-primary mt-10"
        >
          Save New Mail Text
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VueEditor from "./CustomControls/VueEditor.vue";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ["link", "image", "video", "formula"],
//  ["image"],
//  [{ direction: "rtl" }],
//  ["clean"]
];

export default {
  components: {
    VueEditor,
  },
  name: 'DefaultMailNewInvoice',
  mounted() {
    this.mailtext_get();
  },
  data: function() {
    return {
      editortoolbar: editortools,
      mailtype_id: 2,
      mailtext_id: 0,
      mailtext_subject: '',
      mailtext_text: '',
      mail_to: '',
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    mailtext_get() {
      var filter = {
        mailtype_id: {
          operator: '=',
          value: this.mailtype_id,
        },
      }
      this.$store.dispatch('adminmailtext_fetch', { filter: filter })
      .then((resp) => {
        if (resp.data.total > 0) {
          var mailtext = resp.data.result[0];
          this.mailtext_id = mailtext.id;
          this.mailtext_subject = mailtext.mailtext_subject;
          this.mailtext_text = mailtext.mailtext_text;
          this.mail_to = mailtext.mail_to;
        } else {
          this.mailtext_id = 0;
          this.mailtext_subject = '';
          this.mailtext_text = '';
          this.mail_to = '';
        }
      });
    },
    mailtext_create() {
      var adminmailtext =  {
        id: this.mailtext_id,
        mailtype_id: this.mailtype_id,
        mailtext_subject: this.mailtext_subject,
        mailtext_text: this.mailtext_text,
        mail_to: this.mail_to,
      }
      this.$store.dispatch('adminmailtext_create', { adminmailtext: adminmailtext })
      .then((resp) => {
        this.mailtext_id = resp.data.id;
      })
    },
    checkform() {
      return true;
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
        }
      }
    },
  }
}
</script>
<style>
</style>
